<template>
  <div class="product-detail">
    <!-- 头部区域 -->
    <div class="header">
      <div class="header-left">
        <button class="back-btn" @click="goBack">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <div class="title">商品详情</div>
      </div>
    </div>

    <div class="content-scroll">
      <div class="banner">
        <img :src="coverImage" alt="商品主图" />
      </div>

      <div class="summary">
        <div class="title"><span
            style="font-size: 14px; color: #42b983;background-color: #42b98320;padding: 2px 4px;border-radius: 4px;">旗舰店</span>{{
              product?.skuName || '商品详情' }}</div>
        <div class="meta">
          <span>到手价 </span>
          <strong class="theme">¥{{ product?.guidePrice || product?.price }}</strong>
          <span class="split">|</span>
          <span>佣金({{ product?.commissionShare }}%) </span>
          <strong class="theme">
            ¥{{ product?.guidePrice ? (product?.guidePrice * product?.commissionShare / 100).toFixed(2) :
              product?.commission }}
          </strong>
        </div>
      </div>

      <div class="shop-card">
        <div class="shop-info">
          <div class="shop-logo">{{ product?.shopName?.slice(0, 2) }}</div>
          <div class="shop-text" style="flex: 1;">
            <div class="shop-name">{{ product?.shopName || '店铺' }}</div>
            <div class="shop-stars">
              <span v-if="product?.shopLevel">评分 {{ product?.shopLevel }}</span>
              <span v-if="product?.logisticsLvyueScore">物流 {{ product?.logisticsLvyueScore }}</span>
              <span v-if="product?.afterServiceScore">售后 {{ product?.afterServiceScore }}</span>
              <span>商品评价{{ product?.comments / 10000 }}万+</span>
              <span>好评率{{ product?.goodCommentsShare }}%</span>
            </div>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">
          <div style="font-size: 14px;">
            <span>优惠攻略</span>
            <span @click="handleInvalidReport"
              style="margin-left: 10px; cursor: pointer; color: #42b983;font-size: 12px;
              border: 1px solid #42b983;padding: 2px 4px;border-radius: 4px;padding: 1px 4px;line-height: 12px;">失效上报</span>
          </div>
          <div style="display: flex;align-items: center;gap: 10px;font-size: 14px;">
            <span style="background: #42b983;color: #fff;padding: 2px 4px;border-radius: 4px;"
              @click="handleCopyAll">复制全部</span>
            <span style="background: #42b983;color: #fff;padding: 2px 4px;border-radius: 4px;"
              @click="handleCopyOrderLink">复制下单链接</span>
          </div>
        </div>
        <div class="coupon-box" ref="couponBox">
          <div v-if="product?.guideText">
            <div v-if="isRichText(product.guideText)">
              <div class="guide-text" style="white-space: pre-wrap;" v-html="product.guideText"></div>
            </div>
            <div v-else class="guide-text" style="white-space: pre-wrap;">{{ product?.guideText }}</div>
          </div>
          <div v-else>
            <div class="line">{{ product?.skuName }}</div>
            <div class="line">💰京东价￥{{ product?.priceInfo?.lowestPrice }}</div>
            <div class="line">🔥 9.5折 | 💰到手价 ￥{{ product?.priceInfo?.lowestPrice }}</div>

            <div class="line theme" style="align-items: normal;" v-for="dict in product?.couponInfo?.couponList"
              :key="dict.link">
              <span v-if="dict.isBest == 1" class="check-icon" style="white-space: nowrap;">🎉 优惠券减 {{ dict.discount }}
                ：</span>
              <span v-if="dict.isBest == 1" class="discount-text" style="word-break: break-all;">{{ dict.link }}</span>
            </div>
          </div>
          <div class="code" ref="orderLink">🛒 下单：{{ promotionLink || '生成中...' }}</div>
        </div>
      </div>

      <div class="section">
        <div class="section-title">推广素材</div>
        <div class="gallery">
          <div v-for="(img, idx) in gallery" :key="idx" class="gallery-item" @click="toggleSelect(idx)">
            <img :src="img.url" alt="素材" />
            <label class="check">
              <input type="checkbox" :checked="isSelected(idx)" @change.prevent="toggleSelect(idx)" />
              <span class="box" :class="{ checked: isSelected(idx) }"></span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="floating-actions">
      <button class="fab" @click="openPoster">生成海报</button>
      <button class="fab" @click="handleCopyAll">分享赚 ¥{{ product?.guidePrice ? (product?.guidePrice *
        product?.commissionShare / 100).toFixed(2) :
        product?.commission }}</button>
    </div>

    <PosterModal :visible="showPoster" :product="product || {}" :selectedImage="selectedImage" @close="closePoster" />
  </div>
</template>

<script>
import { createPromotionLink, getCurrentUser, reportProductInvalidByItemId } from '@/utils/jdApi'
import { copyRichTextWithMessage } from '@/utils/clipboard'

export default {
  name: 'ProductDetail',
  components: {
    PosterModal: () => import('@/components/PosterModal.vue')
  },
  data() {
    return {
      product: null,
      fallbackCover: '',
      selectedIndexes: [],
      showPoster: false,
      promotionLink: null, // 存储转链后的推广链接
      itemId: null,
      positionId: null,
      currentUser: getCurrentUser()
    }
  },
  computed: {
    coverImage() {
      if (!this.product) return this.fallbackCover
      // 优先使用商品表中的 imageList（JSON 字符串或数组）
      if (this.product.imageList) {
        try {
          const list = typeof this.product.imageList === 'string'
            ? JSON.parse(this.product.imageList)
            : this.product.imageList
          if (Array.isArray(list) && list.length > 0) {
            return list[0]
          }
        } catch (e) {
          // 解析失败则忽略，走兜底
        }
      }
      return this.fallbackCover
    },
    gallery() {
      if (!this.product || !Array.isArray(this.product.imageList)) return []
      return this.product.imageList.map(url => ({ url }))
    },
    selectedImage() {
      // 返回当前已选择的图片列表的第一张
      if (this.selectedIndexes.length > 0) {
        const firstSelectedIndex = this.selectedIndexes[0]
        const gallery = this.gallery
        if (gallery && gallery[firstSelectedIndex]) {
          return gallery[firstSelectedIndex].url
        }
      }
      // 如果没有选择图片，返回默认的第一张图片
      return this.coverImage
    },
  },
  activated() {
    this.initDetail()
  },
  methods: {
    initDetail() {
      try {
        const stored = sessionStorage.getItem('productPageDetail')
        if (!stored) {
          this.$message.error('暂无商品详情，请从列表进入')
          this.$router.replace('/promotion')
          return
        }
        const data = JSON.parse(stored)
        if (!data || !data.itemId) {
          this.$message.error('商品信息异常，请重新选择')
          this.$router.replace('/promotion')
          return
        }
        this.product = this.normalizeGoodsInfoFromDb(data)
        this.itemId = data.itemId
        this.positionId = data.promotionParams?.positionId || this.currentUser?.positionId || null
        if (!this.positionId) {
          this.$message.warning('缺少推广位信息，部分功能无法使用')
        }
        if (this.positionId) {
          this.fetchPromotionLink()
        }
      } catch (e) {
        console.warn('读取本地商品详情失败', e)
        this.$message.error('商品信息异常，请重新选择')
        this.$router.replace('/promotion')
      }
    },
    normalizeGoodsInfoFromDb(data) {
      let imageList = []
      if (data.imageList) {
        try {
          const list = typeof data.imageList === 'string' ? JSON.parse(data.imageList) : data.imageList
          if (Array.isArray(list)) {
            imageList = list
          }
        } catch (e) {
          imageList = []
        }
      }
      return {
        ...data,
        imageList
      }
    },
    // 判断是否为富文本内容
    isRichText(content) {
      // 简单的判断：如果内容包含HTML标签，则认为是富文本
      return /<[^>]*>/.test(content);
    },
    handleInvalidReport() {
      this.$prompt('请输入失效原因', '失效上报', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputPlaceholder: '请输入失效原因...',
        customClass: 'invalid-report-dialog'
      }).then(({ value }) => {
        if (!this.itemId) {
          this.$message.error('商品ID不存在，无法上报')
          return
        }
        const reportedBy = this.currentUser?.positionId
        const invalidReason = value || '商品详情页上报失效'
        reportProductInvalidByItemId(this.itemId, reportedBy, invalidReason)
          .then(response => {
            if (response && response.success) {
              this.$message({
                type: 'success',
                message: '上报成功!'
              })
            } else {
              this.$message.error('上报失败')
            }
          }).catch(() => {
            this.$message.error('上报失败')
          })
      }).catch(() => {
        // 用户取消，避免控制台出现 Uncaught (in promise) cancel
      })
    },
    copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text)
          .then(() => {
            this.showToast('已复制到剪贴板')
          })
          .catch(() => {
            this.fallbackCopy(text)
          })
      } else {
        this.fallbackCopy(text)
      }
    },
    fallbackCopy(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.showToast('已复制到剪贴板')
    },
    handleCopyAll() {
      const box = this.$refs.couponBox
      if (!box) return
      // 获取内容，可能是 HTML 或纯文本
      const content = box.innerHTML || box.innerText || ''
      // 使用统一的工具函数复制，自动处理换行格式
      copyRichTextWithMessage(content, this, '已复制到剪贴板', '复制失败')
    },
    handleCopyOrderLink() {
      const copyLink = link => {
        if (!link) {
          this.showToast('暂无有效链接')
          return
        }
        this.copyToClipboard(link)
        this.showToast('下单链接已复制')
      }

      if (this.promotionLink) {
        copyLink(this.promotionLink)
        return
      }

      this.fetchPromotionLink()
        .then(() => {
          if (this.promotionLink) {
            copyLink(this.promotionLink)
          } else {
            const el = this.$refs.orderLink
            if (!el) return
            const match = String(el.innerText).match(/https?:\/\/\S+/)
            copyLink(match ? match[0] : el.innerText)
          }
        })
        .catch(() => {
          const el = this.$refs.orderLink
          if (!el) return
          const match = String(el.innerText).match(/https?:\/\/\S+/)
          copyLink(match ? match[0] : el.innerText)
        })
    },
    showToast(message) {
      const el = document.createElement('div')
      el.textContent = message
      Object.assign(el.style, {
        position: 'fixed',
        left: '50%',
        bottom: '80px',
        transform: 'translateX(-50%)',
        background: 'rgba(0,0,0,0.75)',
        color: '#fff',
        padding: '8px 12px',
        borderRadius: '6px',
        fontSize: '12px',
        zIndex: '2000',
        transition: 'opacity .2s',
        opacity: '0'
      })
      document.body.appendChild(el)
      requestAnimationFrame(() => { el.style.opacity = '1' })
      setTimeout(() => {
        el.style.opacity = '0'
        setTimeout(() => el.remove(), 200)
      }, 1500)
    },
    openPoster() {
      this.showPoster = true
    },
    closePoster() {
      this.showPoster = false
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1)
    },
    formatPrice(value) {
      if (!value) return '0.00'
      return Number(value).toFixed(2)
    },
    formatPercent(percent) {
      if (!percent) return '0%'
      return Number(percent).toFixed(1) + '%'
    },
    toggleSelect(idx) {
      const i = this.selectedIndexes.indexOf(idx)
      if (i === -1) {
        this.selectedIndexes.push(idx)
      } else {
        this.selectedIndexes.splice(i, 1)
      }
    },
    isSelected(idx) {
      return this.selectedIndexes.indexOf(idx) !== -1
    },
    fetchPromotionLink() {
      if (!this.itemId || !this.positionId) {
        return Promise.resolve(false)
      }
      return createPromotionLink({
        materialId: this.itemId,
        positionId: this.positionId
      }).then(response => {
        if (response && response.code === 200) {
          const linkData = response.link ? (response.link.data || response.link) : response.data
          if (linkData) {
            this.promotionLink = linkData.shortURL || linkData.clickURL || null
            return true
          }
        }
        return false
      }).catch(err => {
        console.warn('获取推广链接失败', err)
        return false
      })
    }
  }
}
</script>

<style scoped>
.theme {
  color: #42b983;
}

.theme-bg {
  background: #42b983;
  color: #fff;
}

.product-detail {
  margin: 0 auto;
  padding: 20px;
  background: #f5f5f5;
  min-height: 100vh;
  box-sizing: border-box;
}

/* 尺寸变量（可按需调整） */
:root {
  --pd-header-h: 56px;
  /* 预估头部高度（含内边距和圆角） */
  --pd-footer-h: 72px;
  /* 底部按钮区域高度（含内边距） */
}

.content-scroll {
  height: calc(100vh - 124px);
  overflow: auto;
  padding-bottom: 12px;
  /* 内容与底部留白 */
}

.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: linear-gradient(135deg, #42b983, #369870);
  padding: 4px;
  border-radius: 12px;
  margin-bottom: 10px;
  color: white;
}

/* 使滚动高度准确：测得头部真实高度作为变量使用 */
.header {
  min-height: var(--pd-header-h);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  color: white;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.back-btn svg {
  width: 20px;
  height: 20px;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.banner {
  position: relative;
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: white;
}

.banner img {
  width: 100%;
  height: auto;
  display: block;
}

.badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: #2c3e50;
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  opacity: 0.9;
}

.price-sticker {
  position: absolute;
  bottom: 12px;
  left: 12px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  padding: 8px 12px;
  line-height: 1.2;
}

.price-now {
  color: #e74c3c;
  font-weight: 700;
}

.price-origin {
  color: #999;
  font-size: 12px;
  text-decoration: line-through;
}

.summary {
  background: white;
  border-radius: 0 0 12px 12px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}

.summary .title {
  margin: 0;
  font-size: 14px;
  color: #2c3e50;
}

.meta {
  color: #666;
  font-size: 14px;
}

.split {
  margin: 0 10px;
  color: #ddd;
}

.cta-group {
  margin-top: 12px;
  display: flex;
  gap: 10px;
}

.btn {
  border: none;
  padding: 10px 14px;
  border-radius: 6px;
  cursor: pointer;
}

.btn.outline {
  background: #fff;
  color: #42b983;
  border: 1px solid #42b983;
}

.btn.small {
  padding: 6px 10px;
  font-size: 12px;
}

.shop-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.shop-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.shop-logo {
  width: 36px;
  height: 36px;
  border-radius: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #42b983;
  color: #fff;
  font-weight: 700;
}

.shop-name {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

.shop-stars {
  font-size: 12px;
  color: #888;
  display: flex;
  column-gap: 10px;
  flex-wrap: wrap;
}

.section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}

.section-title {
  font-size: 16px;
  color: #2c3e50;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
}

.coupon-box {
  background: #f9f9f9;
  border: 1px dashed #42b983;
  padding: 12px;
  border-radius: 8px;
  color: #000;
}

.coupon-box .line {
  font-size: 14px;
  margin: 4px 0;
}

.coupon-box .code {
  font-family: monospace;
  color: #2c3e50;
  background: #fff;
  border: 1px solid #eee;
  padding: 6px;
  border-radius: 6px;
  word-break: break-all;
}

.coupon-box .guide-text {
  font-size: 14px;
  line-height: 1.6;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.coupon-box .guide-text /deep/ p {
  margin: 4px 0;
  display: block;
}

.coupon-box .guide-text /deep/ br {
  display: block;
  line-height: 1.6;
}

.gallery {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.gallery-item {
  position: relative;
}

.gallery img {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #eee;
  display: block;
}

.check {
  position: absolute;
  top: 6px;
  right: 6px;
}

.check input {
  display: none;
}

.check .box {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid #fff;
  background: rgba(0, 0, 0, 0.25);
  display: inline-block;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
}

.check .box.checked {
  background: #42b983;
  border-color: #42b983;
  box-shadow: 0 0 0 1px rgba(66, 185, 131, 0.4);
}

.floating-actions {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: linear-gradient(180deg, rgba(245, 245, 245, 0) 0%, #f5f5f5 60%);
  display: flex;
  gap: 10px;
}

.fab {
  width: 100%;
  background: #42b983;
  color: #fff;
  border: none;
  padding: 10px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.fab:hover {
  background: #369870;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(66, 185, 131, 0.3);
}

/* 响应式设计 */
@media (max-width: 480px) {
  .product-detail {
    padding: 10px;
  }

  .header {
    padding: 4px;
  }

  .summary,
  .shop-card,
  .section {
    padding: 10px;
  }

  .gallery {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

/* 失效上报对话框样式 */
:deep(.invalid-report-dialog) {
  .el-button--primary {
    background-color: #42b983;
    border-color: #42b983;
  }

  .el-button--primary:hover,
  .el-button--primary:focus {
    background-color: #369870;
    border-color: #369870;
  }
}
</style>
